import '../../blocks/installer-form/installer-form.scss';
import '../../blocks/ring-breadcrumbs/ring-breadcrumbs.scss';
import './upgrade-settings.scss';
import InstallerResource from '../../blocks/resource/resource';
import WizardInfo from '../../blocks/wizard-info/wizard-info';
import SslCertificate from '../../blocks/ssl-certificate/ssl-certificate';
import RingDialog from '@jetbrains/ring-ui/components/dialog-ng/dialog-ng';
import ManageOldUpgrade from '../../blocks/manage-old-upgrade/manage-old-upgrade';

import UpgradeSettingsTemplate from './upgrade-settings.html';

import UpgradeSettingsController from './upgrade-settings__controller';

export default angular.module('installer.upgrade-settings', [
  InstallerResource.name,
  WizardInfo.name,
  RingDialog,
  ManageOldUpgrade,
  SslCertificate.name
]).
  controller('UpgradeSettingsController', UpgradeSettingsController).
  config($routeProvider => {
    $routeProvider.
      when('/upgrade/settings', {
        template: UpgradeSettingsTemplate,
        controller: 'UpgradeSettingsController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/upgrade-settings/upgrade-settings.js